import styled from 'styled-components';
import { ModalContent } from '../Modal';

export const CalendarWrapper = styled.div`
`;


export const CalendarModalContent = styled(ModalContent)`
    width: fit-content;
    pointer-events: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: column;
`;
